// extracted by mini-css-extract-plugin
export var radioInputRow = "D_tL";
export var radioInputColumn = "D_tM";
export var inputOptionRow = "D_pT";
export var inputOptionColumn = "D_pV";